import { render, staticRenderFns } from "./ruleModal.vue?vue&type=template&id=0545990e&scoped=true&"
import script from "./ruleModal.vue?vue&type=script&lang=js&"
export * from "./ruleModal.vue?vue&type=script&lang=js&"
import style0 from "./ruleModal.vue?vue&type=style&index=0&id=0545990e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0545990e",
  null
  
)

export default component.exports